import { openDialog } from 'vue3-promise-dialog';
import MsMessageBox from '@/components/messageBox/MsMessageBox.vue';
import MsBottomRightMessageBox from '@/components/messageBox/MsBottomRightMessageBox.vue';
import MessageBoxType from '@/commons/wildcards/constants/MessageBoxType';
import commonFunction from './commonFunction';
function getMsgOption(type, message, title, width, textBtn) {
  if (message && typeof message === 'object' && message.message) {
    return { ...message, ...{ type } };
  } else {
    return {
      type,
      message: message,
      title: title,
      width,
      textBtn,
    };
  }
}

function getMsgOptionCustom(type, message, title, customButton, width, customLabelCheckbox) {
  if (message && typeof message === 'object' && message.message) {
    return { ...message, ...{ type } };
  } else {
    return {
      type,
      message: message,
      title: title,
      customButton,
      width,
      customLabelCheckbox,
    };
  }
}

//#region function đã escapse data

/**
 * Show alert an toàn với xss
 * @param {*} resourceText i18n raw. VD: tm('i18nBaseForm.Message.WarningIncurredDataContent')
 * @param {*} paramMessage mảng tương ứng với số được format trong chuỗi resource text. VD: resource text: "Xóa KH,NCC <<{0}>> không thành công, mã <<{1}>> đã tồn tại", paramMessage: ["Công ty điện máy","KHNCC22555"]
 * @param {*} title title
 * @param {*} width width
 * @returns 
 */
export function showAlertEscapsed(resourceText, paramMessage, title, width) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Info_Warning, message, title, width));
}

export function showIncurredDataWarningEscapsed(resourceText, paramMessage, title, width) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.showIncurredDataWarning, message, title, width));
}


export function showInfoEscapsed(resourceText, paramMessage, title, width, textBtn) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Info_Warning, message, title, width, textBtn));
}

export function showSuccessEscapsed(resourceText, paramMessage, title, width,) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Info_Warning, message, title, width));

}

export function showErrorEscapsed(resourceText, paramMessage, title, width, textBtn, type = MessageBoxType.confirm_Info_Warning) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(type, message, title, width, textBtn));
}
export function showConfirmEscapsed(resourceText, paramMessage, title, width, textBtn) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Yes_No, message, title, width, textBtn));
}

export function showConfirmCancelEscapsed(resourceText, paramMessage, title, width) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Yes_No_Cancel, message, title, width));
}


export function showConfirmDeleteEscapsed(resourceText, paramMessage, title, width) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Delete, message, title, width));
}


export function showErrorCustomEscapsed(resourceText, paramMessage, title, type, width) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(type, message, title, width));
}

export function showConfirmValidateEscapsed(resourceText, paramMessage, title, customButton, width) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOptionCustom(MessageBoxType.showConfirmValidate, message, title, customButton, width));
}


export function showHelpSettlementConfirmEscapsed(resourceText, paramMessage, title, customButton, width) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOptionCustom(MessageBoxType.quick_help_settlement, message, title, customButton, width));
}

export function showConfirmValidateCustomEscapsed(resourceText, paramMessage, title, textBtn, width) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.showConfirmValidateCustom, message, title, width, textBtn));
}

export function showConfirmCustomEscapsed(resourceText, paramMessage, title, width, textBtn) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Yes_No_Custom, message, title, width, textBtn));
}

/**
 * Dialog show confirm với checkbox không hiển thị lại lần sau
 * TVDAT 05.07.2022
 */
export function showConfirmWithDontShowAgainEscapsed(resourceText, paramMessage, title, customLabelCheckbox, textBtn, width) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, {
    type: MsMessageBox.showConfirmWithDontShowAgain,
    message,
    title,
    width,
    textBtn,
    customLabelCheckbox,
  });
}

export function showChooseOptionConfirmEscapsed(resourceText, paramMessage, optionList, title, width) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, {
    type: MessageBoxType.showChooseOptionConfirm,
    message: message,
    title: title,
    width,
    optionList,
    width: 500,
  });
}

/**
 * Dia log chọn theo chiều dọc
 * @param {*} message
 * @param {*} optionList
 * @param {*} title
 * @param {*} width
 * @returns
 */
export function showChooseOptionConfirmVerticalEscapsed(resourceText, paramMessage, optionList, title, width = 500, optionDefault = 1) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, {
    type: MessageBoxType.showChooseOptionConfirmVertical,
    message: message,
    title: title,
    width,
    optionList,
    optionDefault,
  });
}

/**
 * Show form xác nhận tự động hạch toán đồng thời
 * @param {*} message
 * @param {*} title
 * @param {*} customButton
 * @param {*} width
 * @param {*} customLabelCheckbox
 * @returns
 * NVTUAN1 01.08.2022
 */
export function showConfirmAutoGenerateParallelEscapsed(resourceText, paramMessage, title, customButton, width, customLabelCheckbox) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOptionCustom(MessageBoxType.confirmAutoGenerateParallel, message, title, customButton, width, customLabelCheckbox));
}

export function showConfirmIncurredDataEscapsed(resourceText, paramMessage, title, width, textBtn) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirmIncurredData, message, title, width));
}

/**
 * Show xác nhận cập nhật hạch toán đồng thời
 * @param {*} message
 * @param {*} title
 * @param {*} width
 * @returns
 */
export function showConfirmGenerateParallelEscapsed(resourceText, paramMessage, title, width, customCallback) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  let options = getMsgOption(MessageBoxType.confirmGenerateParallel, message, title, width);
  options.customCallback = customCallback;
  return openDialog(MsMessageBox, options);
}

/**
 * Mở popup góc phải màn hình
 * @param {*} message
 * @param {*} title
 * @returns
 */
export function showBottomRightDialogEscapsed(resourceText, paramMessage, title, customCallback) {
  const message = commonFunction.getMessageEscapsed(resourceText, paramMessage);
  let options = getMsgOption(MessageBoxType.confirm_Info_Warning, message, title);
  options.customCallback = customCallback;
  return openDialog(MsBottomRightMessageBox, options);
}
//#endregion




//#region Function chưa escapse data đầu vào, có thể gây lỗi XSS
export function showAlert(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Info_Warning, message, title, width));
}
export function showInfo(message, title, width, textBtn) {
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Info_Warning, message, title, width, textBtn));
}
export function showSuccess(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Info_Warning, message, title, width));
}
export function showError(message, title, width, textBtn, type = MessageBoxType.confirm_Info_Warning) {
  return openDialog(MsMessageBox, getMsgOption(type, message, title, width, textBtn));
}
export function showConfirm(message, title, width, textBtn) {
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Yes_No, message, title, width, textBtn));
}
export function showConfirmCancel(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Yes_No_Cancel, message, title, width));
}
export function showConfirmDelete(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Delete, message, title, width));
}
export function showErrorCustom(message, title, type, width) {
  return openDialog(MsMessageBox, getMsgOption(type, message, title, width));
}
export function showConfirmValidate(message, title, customButton, width) {
  return openDialog(MsMessageBox, getMsgOptionCustom(MessageBoxType.showConfirmValidate, message, title, customButton, width));
}

export function showHelpSettlementConfirm(message, title, customButton, width) {
  return openDialog(MsMessageBox, getMsgOptionCustom(MessageBoxType.quick_help_settlement, message, title, customButton, width));
}

export function showConfirmValidateCustom(message, title, textBtn, width) {
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.showConfirmValidateCustom, message, title, width, textBtn));
}

export function showConfirmCustom(message, title, width, textBtn) {
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirm_Yes_No_Custom, message, title, width, textBtn));
}
/**
 * Dialog show confirm với checkbox không hiển thị lại lần sau
 * TVDAT 05.07.2022
 */
export function showConfirmWithDontShowAgain(message, title, customLabelCheckbox, textBtn, width) {
  return openDialog(MsMessageBox, {
    type: MessageBoxType.showConfirmWithDontShowAgain,
    message,
    title,
    width,
    textBtn,
    customLabelCheckbox,
  });
}

export function showIncurredDataWarning(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.showIncurredDataWarning, message, title, width));
}

export function showChooseOptionConfirm(message, optionList, title, width) {
  return openDialog(MsMessageBox, {
    type: MessageBoxType.showChooseOptionConfirm,
    message: message,
    title: title,
    width,
    optionList,
    width: 500,
  });
}

/**
 * Dia log chọn theo chiều dọc
 * @param {*} message
 * @param {*} optionList
 * @param {*} title
 * @param {*} width
 * @returns
 */
export function showChooseOptionConfirmVertical(message, optionList, title, width = 500, optionDefault = 1) {
  return openDialog(MsMessageBox, {
    type: MessageBoxType.showChooseOptionConfirmVertical,
    message: message,
    title: title,
    width,
    optionList,
    optionDefault,
  });
}

/**
 * Show form xác nhận tự động hạch toán đồng thời
 * @param {*} message
 * @param {*} title
 * @param {*} customButton
 * @param {*} width
 * @param {*} customLabelCheckbox
 * @returns
 * NVTUAN1 01.08.2022
 */
export function showConfirmAutoGenerateParallel(message, title, customButton, width, customLabelCheckbox) {
  return openDialog(MsMessageBox, getMsgOptionCustom(MessageBoxType.confirmAutoGenerateParallel, message, title, customButton, width, customLabelCheckbox));
}

export function showConfirmIncurredData(message, title, width, textBtn) {
  return openDialog(MsMessageBox, getMsgOption(MessageBoxType.confirmIncurredData, message, title, width));
}

/**
 * Show xác nhận cập nhật hạch toán đồng thời
 * @param {*} message
 * @param {*} title
 * @param {*} width
 * @returns
 */
export function showConfirmGenerateParallel(message, title, width, customCallback) {
  let options = getMsgOption(MessageBoxType.confirmGenerateParallel, message, title, width);
  options.customCallback = customCallback;
  return openDialog(MsMessageBox, options);
}

/**
 * Mở popup góc phải màn hình
 * @param {*} message
 * @param {*} title
 * @returns
 */
export function showBottomRightDialog(message, title, customCallback) {
  let options = getMsgOption(MessageBoxType.confirm_Info_Warning, message, title);
  options.customCallback = customCallback;
  return openDialog(MsBottomRightMessageBox, options);
}
//#endregion

